import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import PublicStore from "@/pages/PublicStore";
import TryOn from "@/pages/TryOn";
import Admin from "@/pages/Admin";
import "@/index.css";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/signup" element={<Auth mode="signup" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/store/:slug" element={<PublicStore />} />
            <Route path="/tryon/:id" element={<TryOn />} />
          </Routes>
        </Layout>
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
